import { timeUtils } from '@sato/components';
import { groupBy, meanBy, round } from 'lodash';

import { ChartCoordinate } from '@components/Charts/LineChart';
import { TemperatureMeasurement } from '@models/temperature.types';

export const getTemperatureLineChartCoordinates = (
  measurements: Array<TemperatureMeasurement>
): Array<ChartCoordinate> =>
  Object.entries(
    // Group measurements by day
    groupBy(measurements, (measurement) =>
      timeUtils.formatDate({
        date: measurement.timestamp,
        dateFormat: 'yyyy-MM-dd',
      })
    )
  )

    // Sort by day, ascending
    .sort(([a], [b]) => new Date(a).getTime() - new Date(b).getTime())
    .map(([date, groupMeasurements]) => ({
      x: date,
      /** Get the mean temperature measurement for the day */
      y: round(meanBy(groupMeasurements, 'value'), 1),
    }));
